import { NewsletterApi } from '../../../../api/Newsletter'
import AddNewsletter from '../../../../components/Main/Newsletter/AddNewsletter/AddNewsletter'
import { convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import useActions from '../../../../elements/Hooks/useActions'
import useModalData, { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import { get } from 'lodash'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'

AddNewsletterCont.propTypes = {}

function AddNewsletterCont(props) {
  const key = get(props.match, 'params.key')
  const [masterBody, setMasterBody] = useState('')
  const [baseBody, setBaseBody] = useState('')
  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const isNew = type === MODAL_TYPE_NEW

  const [htmlBody, setHtmlBody] = useState('')
  const setHTML = (editorState) => {
    const body = convertToRaw(editorState.getCurrentContent())
    setHtmlBody({
      body,
      html: draftToHtml(body),
    })
  }

  const {
    visible,
    modalType,
    object: newsletter,
    setObject: setNewsletter,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    fetching,
    fetchObject: fetch,
  } = useModalData(
    (data) => NewsletterApi.create({ ...data, masterHTML: masterBody, html: htmlBody }),
    (data) => NewsletterApi.update({ ...data, masterHTML: masterBody, html: htmlBody }),
    NewsletterApi.remove,
    undefined,
    key,
    NewsletterApi.read,
    (key) => {
      props.history.replace({ pathname: `/newsletter/${key}/update` })
    },
    () => {
      props.history.replace({ pathname: `/newsletter/list/` })
    }
  )

  const { actions, fetchingActions, fetchActions, submittingOperation, submitOperation, handleActions } = useActions(
    'newsletter',
    newsletter,
    setNewsletter,
    NewsletterApi.operation
  )

  return (
    <AddNewsletter
      {...{
        type,
        setMasterBody,
        masterBody,
        baseBody,
        setBaseBody,
        setHTML,
        visible,
        modalType,
        newsletter,
        submitting,
        submit,
        removing,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
        isNew,
        actions,
        fetchingActions,
        fetchActions,
        submittingOperation,
        submitOperation,
        handleActions,
        fetching,
        fetch,
      }}
    />
  )
}

export default withRouter(AddNewsletterCont)
